export const backgroundColors = [
    'white',
    'green',
    'blue',
    'cyan',
    'red',
    'yellow',
    'magenta',
    'black',
    'transparent',
];
//# sourceMappingURL=backgroundColors.js.map